import { IconOtherClose } from '@doltech/icons/IconOtherClose';
import { Modal } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

import { Button } from '../ButtonV2/ButtonV2';
import { colorsV2 } from '../colors-v2';

export interface ConfirmModalProps {
  isModalOpen: boolean;
  onOk: () => void;
  onCancel?: () => void;
  title: string;
  icon?: any;
  children: any;
  okButtonText: string;
  cancelButtonText: string;
  isReverse?: boolean;
  closable?: boolean;
  okButtonDisabled?: boolean;
}

const ConfirmModal = (props: ConfirmModalProps) => {
  const {
    onOk,
    onCancel,
    title,
    isModalOpen,
    children,
    icon,
    okButtonText,
    cancelButtonText,
    isReverse = false,
    closable = true,
    okButtonDisabled = false,
  } = props;

  const FooterButtonRevert = [
    <Button.Secondary
      style={{ marginRight: 16 }}
      key="submit"
      onClick={onOk}
      disabled={okButtonDisabled}
    >
      {okButtonText}
    </Button.Secondary>,
    <Button.Primary key="back" onClick={onCancel}>
      {cancelButtonText}
    </Button.Primary>,
  ];

  const FooterButton = [
    <Button.Secondary style={{ marginRight: 16 }} key="back" onClick={onCancel}>
      {cancelButtonText}
    </Button.Secondary>,
    <Button.Primary key="submit" onClick={onOk} disabled={okButtonDisabled}>
      {okButtonText}
    </Button.Primary>,
  ];

  return (
    <Modal
      onCancel={onCancel}
      className="dol-modal"
      width={480}
      footer={isReverse ? FooterButtonRevert : FooterButton}
      open={isModalOpen}
      closeIcon={<IconOtherClose fontSize={24} />}
      closable={closable}
      destroyOnClose
    >
      <Container>
        <Header>
          <IconHeader>{icon}</IconHeader>
          <Title>{title}</Title>
        </Header>
        <div>{children}</div>
      </Container>
    </Modal>
  );
};

// TODO: Change to Shape Component when component have implemented
const IconHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: 0;
  font-size: 24px;
  min-width: 72px;
  width: 72px;
  height: 72px;
  background-color: ${colorsV2.gray10};
  margin-bottom: 16px;
`;

// TODO: Change to Typography Component when component have updated
const Title = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: ${colorsV2.black100};
`;

const Header = styled.div`
  margin-bottom: 24px;
`;

export const Container = styled.div`
  display: grid;
  background-color: ${colorsV2.white100};
  border-radius: 8px;
  .ant-form-item {
    margin-bottom: 0;
  }
`;

export default React.memo(ConfirmModal);
